import React from 'react';

const Amenities: React.FC = () => {
  const amenities = [
    { icon: "/images/Icono-01.png", name: 'Alimentos' },
    { icon: '/images/Icono-02.png', name: 'Glamping Tepee' },
    { icon: '/images/Icono-03.png', name: 'Regaderas' },
    { icon: '/images/Icono-04.png', name: 'Sanitarios' },
    { icon: '/images/Icono-05.png', name: 'Parking' },
    { icon: '/images/Icono-06.png', name: 'Seguridad' },
  ];

  return (
    <section className="pt-[120px] bg-[#4c654d] md:-mb-24 -mt-20">
      <div className="container mx-auto">
          <div className="flex place-content-center overflow-x-auto pb-4 scrollbar-hide">
          {amenities.map((amenity, index) => (
            <div key={index} className="flex-column w-32 text-center mx-3">
              <div className=" h-36 w-28 flex-column content-center bg-white/5 rounded-full p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <img src={amenity.icon} alt={amenity.name}></img>
                <div className="text-[#171e17] mt-4 text-sm/[15px] flex flex-col justify-center">{amenity.name}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Amenities;
